import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => {
  return {
    offline: {
      padding: theme.spacing(3),
      backgroundColor:'#5a2d80',
      color:'#fff',
      textAlign:'center',
    },
    title: {
      padding: theme.spacing(1),
      fontSize:'14pt',
      fontWeight:'bold',
    },
  };
});

export default function Offline({ children }) {
  const classes = useStyles();
  const [online, setOnline] = React.useState(navigator.onLine);
  const forceOffline=false;

  useEffect(() => {
        if (!online) { return }

    }, [online]);

    useEffect(() => {
        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);

        return () => {
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
        };
    }, []);

    const onOnline = () => {
      console.log("onOnline");
      setOnline(true);
    };
    const onOffline = () => {
      console.log("onOffline");
      setOnline(false);
    };

  return (
    <React.Fragment>
      <If condition={forceOffline || !online}>
        <Box className={classes.offline}>
          <Box className={classes.title}>Vous êtes hors-ligne</Box>
          Veuillez rafraîchir la page lorsque vous êtes connecté.
        </Box>
      </If>
      {children}
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/offline.js